import MediumEditor from 'medium-editor';

const TagExtension = MediumEditor.extensions.button.extend({
  name: 'tag-extension',
  contentDefault: '<span class="medium-editor-toolbar-button">@</span>',
  contentFA: '<span class="medium-editor-toolbar-button">@</span>',
  aria: 'Tag/Mention',

  init() {
    MediumEditor.extensions.button.prototype.init.call(this);
  },

  handleClick() {
    this.base.trigger('showMentionables');
  },
});

export default TagExtension;
